import * as React from 'react';
import { connect } from 'react-redux';
import * as UserModule from './../../../Modules/UserModule';
import LoginForm from '../Forms/_LoginForm';
import {checkApplicationStatus, getApplicationStatus} from 'Modules/TechnicalBreak/Service/TechnicalBreak.Services'

type Props = {};

type ConnectedProps = {
    //
};

type ConnectedDispatch = {
    logInUser: Function;
};

type State = {
    //
};

class Login extends React.Component<Props & ConnectedProps & ConnectedDispatch, State> {
    constructor(props: Props & ConnectedProps & ConnectedDispatch) {
        super(props);
        this.logInUser = this.logInUser.bind(this);
    }
    private async logInUser(userData: UserModule.Types.LoginRequest) {
      const res = await getApplicationStatus()

      if (checkApplicationStatus(res)) {
        window.location.reload();
        return
      }
        await this.props.logInUser(userData);
    }
    public render() {
        return (
            <div className="login__inner">
                <h1>
                    GPS
                    <br />
                    <span>Tracking</span>
                </h1>
                <LoginForm onSubmit={this.logInUser} />
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return state;
}

function mapDispachToProps(dispatch: any) {
    return {
        logInUser: (userData: UserModule.Types.LoginRequest) => dispatch(UserModule.Actions.loginUser(userData.email, userData.password))
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(Login) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/UserSigning/Login/_Login.tsx